module.exports = __webpack_public_path__ + "media/images/popups/popup-new-version-b9d80747458f4c1d20b793c7b3c65e20.png";